<template>

    <b-modal id="reportCardModal" title="レポートカード" ok-only ok-title="閉じる" size="xl"
        dialog-class="custom-wide-modal" modal-class="agent-netenglish-modal">

        <div class="w-25" v-if="aliases.length">

            <div class="row align-items-center">

                <div class="col-auto small text-muted pr-0">
                    受講生アカウント
                </div>
                <div class="col">
                    <select name="accounts" id="accounts" @change="onChangeAccountViewer($event.target.value)"
                        class="form-control form-control-sm">
                        <option v-for="alias in aliases" :key="alias.member_multi_account_id"
                            :value="alias.member_multi_account_id" class="small"
                            :selected="alias.is_default">
                            {{ alias.name }}{{ alias.is_default ? '（デフォルト）' : '' }}
                        </option>
                    </select>
                </div>
            </div>
        </div>


        <div class="card esi-card mt-4">
            <div class="card-header esi-card-header">
                レポートカード一覧
            </div>
            <div class="card-body esi-card-body overflow-auto">

                <div v-if="loading">読み込み中...</div>
                <div v-if="error" class="text-danger">{{ error }}</div>

                <div v-if="reports.length">

                    <table cellspacing="0" cellpadding="0" class="table table-striped" width="100%">
                        <thead>
                            <tr>
                                <th>レッスン日時</th>
                                <th>レッスン科目</th>
                                <th>レッスンコース</th>
                                <th>レッスン教材</th>
                                <th>評価</th>
                                <th>コメント</th>
                                <th>講師</th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="report in reports" :key="'reportcard-' + report.id">
                                <td>{{ formatLessonDateTime(report.lesson_time || report.created_at) }}</td>
                                <td><span v-if="report.lesson_subject">{{ report.lesson_subject }}</span></td>
                                <td><span v-if="report.lesson_course">{{ report.lesson_course }}</span></td>
                                <td><span v-if="report.lesson_material">{{ report.lesson_material }}</span></td>
                                <td><span v-if="report.grade">{{ formatGrade(report.grade) }}</span></td>
                                <td><span v-if="report.comment" v-html="report.comment"></span></td>
                                <td><span v-if="report.tutor_name">{{ report.tutor_name }}</span></td>
                            </tr>

                        </tbody>
                    </table>

                    <div v-if="lastPage > 1" class="pagination">
                        <button type="button" class="btn btn-sm mr-1" disabled>ページ {{ currentPage }} / {{ lastPage }}</button>
                        <button type="button" @click="prevPage" :disabled="currentPage === 1"
                            class="btn btn-primary btn-sm mr-1">前へ</button>
                        <button v-for="page in pageNumbers" :key="page" type="button"
                            :class="{ active: currentPage === page }"
                            class="mr-1 btn btn-primary btn-sm" @click="goToPage(page)">
                            {{ page }}
                        </button>
                        <button type="button" @click="nextPage" :disabled="currentPage === lastPage"
                            class="btn btn-primary btn-sm mr-1">次へ</button>

                    </div>
                </div>
                <div v-else>
                    <span v-if="loading == false">現在、表示できるレポートカードはありません。</span>
                </div>

            </div>
        </div>

    </b-modal>

</template>

<style>
.custom-wide-modal {
    max-width: 95%;
    width: 95%;
}
</style>


<style scoped>
.card-body.overflow-auto {
    overflow: auto;
}

.pagination {
    display: inline-block !important;
}
</style>

<script>
export default {
    props: {
        firstname: String,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            reports: [],

            loading: false,
            error: null,
            currentPage: 1,
            lastPage: 1,
            perPage: 10,
            member: null,

            pageNumbers: [],

            accountID: null,
            aliases: []
        };
    },
    mounted() {

    },
    methods: {

        onChangeAccountViewer(event) {
            this.accountID = event;
            this.getReportCards();
        },
        reset() {
            this.reports = [];

            this.loading = false;
            this.error = null;
            this.currentPage = 1;
            this.lastPage = 1;
            this.perPage = 10;
            this.member = null;
            this.accountID = null;
            this.aliases = [];
        },
        openReportCard(member) {
            this.reset();
            this.member = member;
            this.$bvModal.show('reportCardModal');
            this.getReportCards();
        },
        async getReportCards(page = 1) {
            this.loading = true;
            this.currentPage = page;
            this.error = null;

            axios.post("/api/getReportCards?api_token=" + this.api_token, {
                method: "POST",
                agentUserID: this.$props.agent_user_id,
                accountID: this.accountID,
                memberID: this.member,
                page: this.currentPage,
                per_page: this.perPage
            }).then(response => {

                if (response.data.success === false) {
                    this.error = response.data.message || 'レポートカードの取得に失敗しました。';
                } else {
                    this.reports = response.data.reports.data;
                    this.lastPage = response.data.reports.last_page;
                    this.aliases = response.data.aliases || [];
                    this.updatePageNumbers();
                }

                this.loading = false;

            }).catch(() => {
                this.error = 'レポートカードの取得に失敗しました。';
                this.loading = false;
            });
        },
        goToPage(num) {
            this.getReportCards(num);
        },
        nextPage() {
            if (this.currentPage < this.lastPage) {
                this.getReportCards(this.currentPage + 1);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.getReportCards(this.currentPage - 1);
            }
        },

        formatGrade(grade) {
            return String(grade).replace(/_/g, ' ');
        },

        formatLessonDateTime(dateString) {
            if (!dateString) {
                return '';
            }
            const date = new Date(dateString);
            const jstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);

            if (jstDate.getHours() === 0) {
                jstDate.setDate(jstDate.getDate() - 1);
                return `${jstDate.getFullYear()}年 ${String(jstDate.getMonth() + 1).padStart(2, '0')}月 ${String(jstDate.getDate()).padStart(2, '0')}日 24:${String(jstDate.getMinutes()).padStart(2, '0')}:${String(jstDate.getSeconds()).padStart(2, '0')}`;
            }

            return `${jstDate.getFullYear()}年 ${String(jstDate.getMonth() + 1).padStart(2, '0')}月 ${String(jstDate.getDate()).padStart(2, '0')}日 ${String(jstDate.getHours()).padStart(2, '0')}:${String(jstDate.getMinutes()).padStart(2, '0')}:${String(jstDate.getSeconds()).padStart(2, '0')}`;
        },

        updatePageNumbers() {

            const maxPagesToShow = 15;
            const halfRange = Math.floor(maxPagesToShow / 2);

            let startPage = this.currentPage - halfRange;
            let endPage = this.currentPage + halfRange;

            if (startPage < 1) {
                startPage = 1;
                endPage = Math.min(maxPagesToShow, this.lastPage);
            }

            if (endPage > this.lastPage) {
                endPage = this.lastPage;
                startPage = Math.max(1, this.lastPage - maxPagesToShow + 1);
            }

            this.pageNumbers = [];

            for (let i = startPage; i <= endPage; i++) {
                this.pageNumbers.push(i);
            }

        }

    },

};

</script>
